import { createFileRoute } from "@tanstack/react-router";
import ShowroomIntroPerformanceDebug from "lib/components/debug/ShowroomIntroPerformanceDebug";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";

function ShowroomIntroPerformanceDebugPage() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Showroom Intro Performance Debug")}</title>
        <meta name="robots" content="noindex" />
      </Head>

      <ShowroomProvider>
        <ShowroomIntroPerformanceDebug />
      </ShowroomProvider>
    </>
  );
}

export const Route = createFileRoute("/debug/showroom-intro-performance")({
  component: ShowroomIntroPerformanceDebugPage,
  staticData: { isPublicPage: true },
});
